module.exports = __webpack_public_path__ + "fonts/Montserrat-Thin.0052573.ttf";